import React from 'react';
import { termsOfServiceContent } from '../data/homeContent';

const accent = "#16bb8b";

const Section = ({ title, children }) => (
  <section className="mb-10 pl-6 border-l-4" style={{ borderColor: accent }}>
    <h2 className="text-2xl font-bold mb-2" style={{ color: accent }}>{title}</h2>
    <div className="text-gray-700">{children}</div>
  </section>
);

const TermsOfService = () => (
  <div className="max-w-4xl mx-auto px-4 py-12 bg-gray-50 min-h-screen">
    <h1 className="text-4xl font-extrabold mb-2" style={{ color: accent }}>
      {termsOfServiceContent.title}
    </h1>
    <h2 className="text-xl font-semibold mb-6" style={{ color: accent }}>
      {termsOfServiceContent.subtitle}
    </h2>
    <p className="text-gray-700 mb-8 whitespace-pre-line">{termsOfServiceContent.intro}</p>
    <div className="mb-8">
      <h3 className="text-lg font-bold mb-2" style={{ color: accent }}>Table of Contents</h3>
      <ol className="list-decimal ml-8 text-gray-700">
        {termsOfServiceContent.toc.map((item, idx) => (
          <li key={idx}>{item}</li>
        ))}
      </ol>
    </div>
    {termsOfServiceContent.sections.map((section, idx) => (
      <Section title={section.title} key={section.title}>
        {section.content.map((item, i) =>
          Array.isArray(item) ? (
            <ul className="list-disc ml-6 mb-2" key={i}>
              {item.map((li, j) => (
                <li key={j}>{li}</li>
              ))}
            </ul>
          ) : (
            <p className="mb-2" key={i}>{item}</p>
          )
        )}
      </Section>
    ))}
  </div>
);

export default TermsOfService; 